export default __webpack_public_path__ + "static/media/45_desktop.fd97d4ee.jpg";